var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComposer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.5V6.33333L24.5 4V19.1667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 25C8.933 25 10.5 23.433 10.5 21.5C10.5 19.567 8.933 18 7 18C5.067 18 3.5 19.567 3.5 21.5C3.5 23.433 5.067 25 7 25Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.6666C22.933 22.6666 24.5 21.0996 24.5 19.1666C24.5 17.2336 22.933 15.6666 21 15.6666C19.067 15.6666 17.5 17.2336 17.5 19.1666C17.5 21.0996 19.067 22.6666 21 22.6666Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComposer);
export default __webpack_public_path__ + "static/media/Icon-Composer.254b86ef3a9f7b8408dff867661feaa8.svg";
export { ForwardRef as ReactComponent };